<template>
  <div class="contbg">
    <a-card>
      <a-row v-if="isTest">{{ auditContDetail.id }}</a-row>
      <a-row class="d_title">{{ auditContDetail.msgTitle }}
        <a-tag style="margin-left:20px" v-if="auditContDetail.msgAttribute==1" color="purple">取消/过期</a-tag>
      </a-row>
      <a-row :gutter="[40,32]">
        <a-col :md="8" :sm="24">上传员工：{{ auditContDetail.uid }}/{{ auditContDetail.userName }}/{{ auditContDetail.userOrg }}</a-col>
        <a-col :md="8" :sm="24">上传时间：{{ auditContDetail.submitTime }}</a-col>
      </a-row>
      <a-row :gutter="[40,32]" v-if="auditContDetail.manual&&auditContDetail.manual.status!=0">
        <a-col :md="8" :sm="24">审核人：{{ auditContDetail.reviewerName }}</a-col>
        <a-col :md="8" :sm="24">审核时间：{{ auditContDetail.manualAuditTime }}</a-col>
      </a-row>
    </a-card>
    <a-card class="mgt16" title="内容" id="iframe_wrapper">
      <iframe class="iframe" name="refresh_name" id="iframe_material" frameborder="0"></iframe>
    </a-card>
    <a-card class="mgt16" title="机器审核结果" v-if="auditContDetail.ai">
      <div :class="auditContDetail.ai.status==0?'ad_status pending':(auditContDetail.ai.status==1?'ad_status pass':'ad_status unpass')">{{ auditContDetail.ai.status | getAIStatus }}</div>
      <div class="ad_info noline nopoint" v-if="auditContDetail.ai.details">
        <template v-if="auditContDetail.ai.details.file&&auditContDetail.ai.details.file.length>0">
          <div class="ad_li" v-for="(file,j) in auditContDetail.ai.details.file" :key="'file_text'+j">
            <template v-if="file.text&&file.text.length>0">
              <div class="ad_left">
                <div>文件机审文本结果</div>
              </div>
              <div class="ad_right" v-if="file.text&&file.text.length>0">
                <div class="ad_voi_item" v-for="(item,i) in file.text" :key="i">
                  <div class="ad_label"><span></span><span>{{ item.label }}</span></div>
                  <div>{{ item.content }}</div>
                </div>
              </div>
            </template>
          </div>
          <div class="ad_li" v-for="(file,j) in auditContDetail.ai.details.file" :key="'file_image'+j">
            <template v-if="file.image&&file.image.length>0">
              <div class="ad_left">
                <div>文件机审图片结果</div>
              </div>
              <div class="ad_right ad_img" v-if="file.image&&file.image.length>0">
                <div class="ad_img_item" v-for="(item,i) in file.image" :key="'file_image_'+i">
                  <ImgView :src="item.url" />
                  <div class="ad_label"><span></span><span>{{ item.label }}</span></div>
                </div>
              </div>
            </template>
          </div>
        </template>
        <div class="ad_li" v-if="auditContDetail.ai.details.video&&auditContDetail.ai.details.video.length>0">
          <div v-for="(video,j) in auditContDetail.ai.details.video" :key="'video_'+j">
            <div class="ad_left">
              <div>视频机审结果</div>
            </div>
            <div class="ad_right ad_img">
              <div class="ad_img_item" v-for="(item,i) in video.image" :key="'video_img'+i">
                <ImgView :src="item.url" />
                <div class="ad_label"><span>{{ item.startTimeOffset|showTime }}</span><span>{{ item.label }}</span></div>
                <div>{{ item.keywordSet | formatKeyWord }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="ad_li" v-if="auditContDetail.ai.details.voice">
          <div class="ad_left">
            <div>语音机审结果</div>
          </div>
          <div class="ad_right">
            <div class="ad_voi_item" v-for="(item,i) in auditContDetail.ai.details.voice.details" :key="'voice_'+i">
              <div class="ad_label"><span>{{ item.startTime|showTime }}</span><span>{{ item.label }}</span></div>
              <div>{{ item.text }}</div>
            </div>
          </div>
        </div>
        <div class="ad_li" v-if="auditContDetail.ai.details.webpage&&auditContDetail.ai.details.webpage.text&&auditContDetail.ai.details.webpage.text.length>0">
          <div class="ad_left">
            <div>网页机审文本结果</div>
          </div>
          <div class="ad_right" v-if="auditContDetail.ai.details.webpage.text&&auditContDetail.ai.details.webpage.text.length>0">
            <div class="ad_voi_item" v-for="(item,i) in auditContDetail.ai.details.webpage.text" :key="'webpage_text_'+i">
              <div class="ad_label"><span></span><span>{{ item.label | formatLabel }}</span></div>
              <div>{{ item.details|getWebPageContent }}</div>
            </div>
          </div>
        </div>
        <div class="ad_li" v-if="auditContDetail.ai.details.webpage&&auditContDetail.ai.details.webpage.image&&auditContDetail.ai.details.webpage.image.length>0">
          <div class="ad_left">
            <div>网页机审图像结果</div>
          </div>
          <div class="ad_right ad_img" v-if="auditContDetail.ai.details.webpage.image&&auditContDetail.ai.details.webpage.image.length>0">
            <div class="ad_img_item" v-for="(item,i) in auditContDetail.ai.details.webpage.image" :key="'webpage_image_'+i">
              <ImgView :src="item.url" />
              <template v-if="item.results">
                <div v-if="info.suggestion > 1" class="ad_label" v-for="(info,j) in item.results" :key="'webpage_image'+j">
                  <span>{{ info.scene }}</span><span>{{ info.label }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="ad_li" v-if="auditContDetail.ai.details.text">
          <div class="ad_left">
            <div>文本机审结果</div>
          </div>
          <div class="ad_right" v-if="auditContDetail.ai.details.text&&auditContDetail.ai.details.text.length>0">
            <div class="ad_voi_item" v-for="(item,i) in auditContDetail.ai.details.text" :key="'text_'+i">
              <div class="ad_label"><span></span><span>{{ item.label }}</span></div>
              <div>{{ item.details|getWebPageContent }}</div>
            </div>
          </div>
        </div>
      </div>
    </a-card>
    <a-card class="mgt16" title="人工审核结果" v-if="auditContDetail.manual&&auditContDetail.manual.status!=0">
      <div :class="auditContDetail.manual.status==0?'ad_status pending':(auditContDetail.manual.status==1?'ad_status pass':'ad_status unpass')">{{ auditContDetail.manual.status | getAIStatus }}</div>
      <div class="ad_info noline nopoint">
        <div class="ad_li">
          <div class="ad_left">
            <div>{{ auditContDetail.manual.status == 2?'拒绝':'通过' }}原因</div>
          </div>
          <div class="ad_right">
            <div class="refused" v-html="auditContDetail.manual.details"></div>
          </div>
        </div>
      </div>
    </a-card>
    <a-card v-else class="mgt16" title="人工审核操作">
      <a-form-model ref="ruleForm" :rules="rules" :model="auditObj">
        <a-form-model-item
          label="审核"
          prop="status"
          :labelCol="{ span: 2 }"
          :wrapperCol="{ span: 16 }"
        >
          <a-radio-group v-model="auditObj.status" :options="statusList" />
        </a-form-model-item>
        <a-form-model-item
          v-show="auditObj.status==2"
          label="拒绝原因"
          :labelCol="{ span: 2 }"
          :wrapperCol="{ span: 16 }"
        >
          <vue-tinymce
            v-model="auditObj.reason"
            :setup="tinymceSetup"
            :setting="setting" />
        </a-form-model-item>
        <div class="ant-col ant-col-2 ant-form-item-label"></div>
        <a-form-model-item
          label=""
          :labelCol="{ span: 2 }"
          :wrapperCol="{ span: 16 }"
        >
          <a-button type="primary" @click="save">审核完成</a-button>
          <a-button class="mgl8" @click="close">取消</a-button>
        </a-form-model-item>
      </a-form-model>

    </a-card>
    <a-card class="mgt16 verify_history" v-if="id && submitLog.length" title="历史审核记录">
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
        <div v-for="(item, index) in submitLog" :key="index">
          <a-form-item :label="(index + 1) + '.上传时间'">
            {{ item.msgSubmitTime }} <a-button type="link" @click="toHistoryDetail(item.id)">查看详情</a-button>
          </a-form-item>
          <a-form-item label="机审结果">
            {{ item.aiAuditStatus | getAIStatus }}
          </a-form-item>
          <a-form-item label="人工审核" v-if="item.msgAttribute != 1 || item.manualAuditStatus">
            <a-row>
              <a-col :span="3">{{ item.manualAuditStatus | getAIStatus }}</a-col>
              <template v-if="item.manualAuditStatus">
                <a-col :span="8">
                  <a-form-item :label-col="{ span: 6 }" label="审核人">
                    {{ item.reviewerName }}
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item :label-col="{ span: 6 }" label="审核时间">
                    {{ item.manualAuditTime }}
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form-item>
          <!-- 1 取消 0 默认 -->
          <a-form-item v-if="item.msgAttribute == 1 && !item.manualAuditStatus" label="消息状态">
            取消/已过期
          </a-form-item>
        </div>
      </a-form-model>
    </a-card>
    <ImgPreview ref="imgpreview"></ImgPreview>
  </div>
</template>

<script>
  import { saveEgcms,getEgcms, getAllDetail } from '@/api/markethelp'
  import { getEgcTypeList } from '@/api/account'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import ImgView from '../../components/ImgView'
  import ImgPreview from '../../components/ImgPreview'

  export default {
    name:'AuditcontDetail',
    data(){
      return{
        labelCol: { span: 2 },
        wrapperCol: { span: 22 },
        submitLog: [],
        id:this.$route.params.id,
        playspeed:1,
        speedList:['1.0','1.25','1.5','2.0'],
        statusList:[{label:'通过',value:1},{label:'拒绝',value:2}],
        auditObj:{
          status:2,
          reason:''
        },
        rules:{
          status:[
            { required: true, message: '请选择审核结果', trigger: 'blur' }
          ],
          reason:[
            // {max:100,message:"拒绝原因不能超过100字符",trigger:'blur'}
          ]
        },
        refuseList:[],
        fileList:[],
        uploadedlist:[],
        loading:false,
        auditContDetail:{},
        mcnupload:'',
        domain:'',
        submiting:false,
        isTest:false,
        historyId: '',
        setting:{
          height:200,
          toolbar: false,
          menu:false,
          menubar:false,
          plugins: 'image paste',
          paste_data_images:true,
          branding:false,
          images_upload_handler:function(blobInfo, succFun, failFun){
            console.log('上传图片')
            var xhr, formData
            var file = blobInfo.blob()//转化为易于理解的file对象
            xhr = new XMLHttpRequest()
            xhr.withCredentials = true
            xhr.open('POST',  window.base_url + '/mcn/upload')
            xhr.setRequestHeader('Authorization', Vue.ls.get(ACCESS_TOKEN))
            xhr.onload = function() {
              var json
              if (xhr.status != 200) {
                  failFun('HTTP Error: ' + xhr.status)
                  return
              }
              json = JSON.parse(xhr.responseText)
              if(json.code==1){
                succFun(json.result)
              }
            }
            formData = new FormData()
            formData.append('file', file, file.name )//此处与源文档不一样
            xhr.send(formData)
          }
        }
      }
    },
    created(){
      this.init()
    },
    mounted() {
      window.addEventListener('message', this.previewImg)
      if(location.href.indexOf('test')>=0||location.href.indexOf('localhost')>=0){
        this.isTest = true
      }
      this.historyId = this.$route.query?.historyId

      if(!this.id && !this.historyId){
        this.close()
        return
      }
      // this.getRefuses();
      this.getDetail()
    },
    beforeDestroy () {
      window.removeEventListener('message', this.previewImg)
    },
    methods: {
      toHistoryDetail (id) {
        const url = `${location.origin}${location.pathname}?historyId=${id}`
        window.open(url)
      },
      previewImg (e) {
        if (e.data.url) {
          this.$refs.imgpreview?.show(e.data.url)
        }
      },
      tinymceSetup(editor){
        console.log('editor',editor)
      },
      init(){
        this.domain = window.base_url
        this.mcnupload = this.domain + '/mcn/upload'
        // 配置上传头
        this.uploadHeaders = {
          'Authorization':Vue.ls.get(ACCESS_TOKEN)
        }
      },
      // 由于跨域刷新iframe不支持，只想到去删除旧iframe创建新的iframe
      setIframe () {
        const iframe_wrapper = document.querySelector('#iframe_wrapper .ant-card-body')
        const iframe = document.getElementById('iframe_material')
        iframe_wrapper.removeChild(iframe)
        const newIframe = document.createElement('iframe')
        newIframe.setAttribute('src', this.auditContDetail.msgContent)
        newIframe.setAttribute('frameborder', '0')
        newIframe.setAttribute('allow', 'fullscreen')
        newIframe.setAttribute('id', 'iframe_material')
        newIframe.classList.add('iframe')
        const height = iframe_wrapper.offsetWidth * 0.6 * 1.4
        newIframe.style.height = height + 'px'
        iframe_wrapper.appendChild(newIframe)
      },
      getDetail(){
        var params = {
          id: this.id || this.historyId
        }
        const api = this.id ? getAllDetail : getEgcms
        api(params).then(res=>{
          if(res.code==1){
            this.auditContDetail = res.result
            this.submitLog = res.result?.submitLog || []

            if (this.auditContDetail.msgType == 3) {
              this.setIframe()
            }
            // 处理审核拒绝内容的图片展示
            this.$nextTick(()=>{
              var refd = document.getElementsByClassName('refused')
              if(refd&&refd.length>0){
                refd = refd[0]
                var imgs = refd.getElementsByTagName('img')
                for(let i=0;i<imgs.length;i++){
                  var img = imgs[i]
                  img.style.maxWidth = '100%'
                }
              }
            })
          }
        })
      },
      close(){
        // this.$router.go(-1);
        this.$router.push('/auditcont/marketList')
      },
      getRefuses(){
        getEgcTypeList().then(res=>{
          if(res.code==1){
            var tmp = res.result
            for(let i=0;i<tmp.length;i++){
              if(tmp[i]&&tmp[i].auditType&&tmp[i].auditType.length>0){
                var tmpJ = tmp[i].auditType
                for(let j=0;j<tmpJ.length;j++){
                  tmpJ[j].sel = false
                }
              }
            }
            this.refuseList =tmp
          }
        })
      },
      beforeUpload(file){
        const isLimit = file.size / 1024 / 1024 < 5
        return new Promise((resolve,reject)=>{
          if (!isLimit) {
            this.$message.error('文件大小限制5M')
            reject(file)
          }else{
            resolve(file)
          }
        })
      },
      // 处理上传文件
      handleUploadFile(info) {
        switch (info.file.status) {
          case 'uploading':
            this.fileList = info.fileList.slice(-1)
            this.loading = true
            break
          case 'removed':
            this.loading = false
            var uid = info.file.uid
            var tmplist = []
            for(let i=0;i<this.uploadedlist.length;i++){
              if(uid!=this.uploadedlist[i].uid){
                tmplist.push(this.uploadedlist[i])
              }
            }
            this.uploadedlist =tmplist
            break
          case 'done':
            const { code, result } = info.file.response
            if (code !== 1) return
            this.uploadedlist.push({uid:info.file.uid,src:info.file.response.result})
            this.loading = false
            break
          default:
            break
        }
      },
      save(){
        this.$refs.ruleForm.validate(valid => {
          if (!valid) return false

          var params = {...this.auditObj}
          // 上传图片
          params.id = this.id

          if(this.auditObj.status==2&&this.auditObj.reason==''){
            //必须有拒绝原因
            this.$message.error('必须选择拒绝原因')
            return false
          }

          if(this.submiting){
            return
          }
          this.submiting = true


          saveEgcms(params).then(res=>{
            this.submiting = false
            const { code, message, result } = res
            if(code==1){
              this.$message.success('审核成功')
              this.close()
            } else if (code == -101) {
              const that = this
              this.$confirm({
                title: '提示',
                content: message,
                onOk () {
                  that.id = result
                  that.$route.params.id = result
                  that.getDetail()
                },
                onCancel () {
                }
              })
            } else {
              this.$message.error(message)
            }
          })
        })
      }
    },
    filters:{
      formatKeyWord (val) {
        return val ? val.join(' ') : val
      },
      formatLabel (val) {
        return val === 'customized' ? '自定义敏感词' : val
      },
      getAIStatus(status){
        var str = ''
        switch (status){
          case 0:
            str='未审核'
          break
          case 1:
            str='审核通过'
          break
          case 2:
            str='审核未通过'
          break
        }
        return str
      },
      showTime(second){
        second = Math.floor(second)
        if(second==0){
          second = 1
        }
        var hours = Math.floor(second/3600)
        if(hours<=9){
          hours ='0'+hours
        }
        var mins = Math.floor((second-3600*hours)/60)
        if(mins<=9){
          mins ='0'+mins
        }
        var seconds = second%60
        if(seconds<=9){
          seconds ='0'+seconds
        }
        return `${hours}:${mins}:${seconds}`
      },
      getWebPageContent(list){
        var str = ''
        if(list&&list.length>0){
          for(let i=0;i<list.length;i++){
            var item = list[i].contexts
            if(item&&item.length>0){
              for(let j=0;j<item.length;j++){
                str += item[j].context + ' '
              }
            }
          }
        }
        return str
      }
    },
    components:{ImgView, ImgPreview}
  }
</script>

<style lang="less" scoped>
.contbg{
  background:#edf0f3;
  .verify_history {
    /deep/.ant-form-item {
      margin-bottom: 0;
      .ant-form-item-label, .ant-form-item-control {
        line-height: 30px;
      }
    }
  }
  .d_title{
    font-size:20px;
    color:rgba(0,0,0,0.85);
    font-weight: 600;
    margin-bottom:16px;
  }
  .d_cont{
    font-size:14px;
    color:rgba(0,0,0,0.65);
  }
  /deep/.iframe{
    width: 90%;
    height: 870px;
    overflow-y: auto;
    border:1px solid #e9e9e9;
    box-sizing: border-box;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  .video{
    max-width:100%;
    max-height:500px;
  }
  .playspeed{
    width: 95px;
    margin-top:16px;
    display:block;
    &.sel{
      color:#fff;
      background:#1890FF;
    }
  }
  .mgt16{
    margin-top: 16px;
  }
}

.auditrecord{
  margin:0;
  padding:0;
  list-style: none;
  li{
    display: flex;
    flex-flow:row nowrap;
    font-size:14px;
    height:46px;
    position: relative;
    .ad_time{
      color:#808080;
    }
    .ad_recd{
      position: relative;
      margin-left:32px;
      color:#4D4D4D;
      &::before{
        content:'';
        border-left:1px solid #B3B3B3;
        height:100%;
        position: absolute;
        left: -20px;
        top: 11px;
      }
      &::after{
        content:'';
        width:7px;
        height:7px;
        border-radius:7px;
        background:#B3B3B3;
        position: absolute;
        left: -23px;
        top: 7px;
      }
      span:nth-child(1){
        padding-right:8px;
      }
      span:nth-last-child(1){
        color:#000;
        display: inline-block;
        padding-left:8px;
        border-left:1px solid rgba(0,0,0,0.25);
      }
    }
    .noline{
      &::before{
        border:0 !important;
      }
    }
    &:nth-last-child(1){
      .ad_recd{
        &::before{
          border:0 !important;
        }
      }
    }
  }
}

.refuse_list{
  font-size:14px;
  .g_name{
    color:rgba(0,0,0,0.45);
  }
  ul{
    margin:0;
    padding:0;
    list-style: none;
    li{
      display:inline-block;
      padding:0 8px;
      height:22px;
      line-height:22px;
      color:rgba(0,0,0,0.65);
      background:#F0F2F5;
      margin-right:16px;
      cursor: pointer;
      &.sel{
        background:#1890FF;
        color:#fff;
      }
    }
  }
}

.reason{
  width:500px;
  margin-top:10px;
}

.ad_status{
  height:22px;
  line-height: 22px;
  padding:0 8px;
  font-size:14px;
  color:#fff;
  border-radius:2px;
  display: inline-block;
  &.pending{
    background:#FFB700;
  }
  &.pass{
    background: #52C41A;
  }
  &.unpass{
    background:#F5222D
  }
}

.ad_info{
  width:auto;
  position: relative;
  margin-top:16px;
  .ad_li{
    display: flex;
    flex-flow:row nowrap;
    margin-bottom:24px;
    .ad_left{
      width: 140px;
      flex-shrink: 0;
      color:#4D4D4D;
      margin-right:10px;
      display: flex;
      flex-flow:column;
      .ad_opt{
        color:#1890FF;
        cursor: pointer;
        display:flex;
        flex-flow:row nowrap;
        align-items: center;
        margin-top:16px;
        span{
          margin-right:4px;
        }
      }
    }
    .ad_right{
      display:flex;
      flex-flow:column;
      .ad_label{
        display: flex;
        flex-flow:row nowrap;
        max-width:500px;
        span{
          color:rgba(0,0,0,0.65);
          font-size:14px;
          margin-right:6px;
        }
        span:nth-child(2){
          color:#F5222D;
        }
      }
      .ad_voi_item{
        display: flex;
        flex-flow:row nowrap;
        position: relative;
        margin-bottom:8px;
        div:nth-child(2){
          margin-left:19px;
          &::before{
            border-left:1px solid rgba(0,0,0,0.25);
            content:'';
            width:1px;
            height:100%;
            position:relative;
            left:-8px;
          }
        }
      }
      &.ad_img{
        display:flex;
        flex-flow:row wrap;
        .ad_img_item{
          margin-right:24px;
          max-width:150px;
          img{
            height:56px;
            width:100px;
            margin-bottom:8px;
          }
        }
      }
    }
  }
}

.mgl8{
  margin-left:8px;
}
</style>
